import script from "./manual-record.vue?vue&type=script&setup=true&lang=js"
export * from "./manual-record.vue?vue&type=script&setup=true&lang=js"

import "./manual-record.vue?vue&type=style&index=0&id=72b784f2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b784f2"]])

export default __exports__